import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"

interface BackButtonProps {
  onClick: () => void
}

/**
 * Back button component with consistent styling
 */
export function BackButton({ onClick }: BackButtonProps) {
  return (
    <Button
      variant="outline"
      size="default"
      className="flex items-center gap-2"
      onClick={onClick}
    >
      <ArrowLeft className="h-4 w-4" />
      <span>Back</span>
    </Button>
  )
}
